import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from "@angular/forms";
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from 'primeng/table';
import { TabsModule } from 'primeng/tabs';
import { Subject } from 'rxjs';
import { TablepageBaseComponent } from '../../abstract/tablepage-base/tablepage-base.component';
import { DepartmentDialogComponent } from '../../dialogs/department-dialog/department-dialog.component';
import { Department } from '../../models/department';
import { ApiService } from '../../services/api.service';
import { UiNotificationService } from '../../services/ui-notification.service';
import { Reset } from '../../utilities/reset';

@Component({
  selector: 'app-departments',
  imports: [
    CommonModule,
    FormsModule,
    TableModule,
    TabsModule,
    InputTextModule,
    ButtonModule,
    DepartmentDialogComponent,
    TablepageBaseComponent,
    TranslatePipe
  ],
  standalone: true,
  templateUrl: './departments.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: ``
})
export class DepartmentsComponent implements OnInit, OnDestroy {
  messageService = inject(UiNotificationService);

  departments!: Department[];
  selectedDepartment: Department = Reset.department();
  newDepartment: Department = Reset.department();

  filter_active: any[] = [];

  loading: boolean = false;
  dtTrigger: Subject<boolean> = new Subject<boolean>();

  showDialog: boolean = false;
  isNew: boolean = false;

  constructor(private apiService: ApiService) {
  }

  ngOnInit(): void {
    this.loadData();
  }

  private loadData(): void {
    this.loading = true;

    this.apiService.getDepartments().subscribe({
      next: (data) => {
        this.departments = data;
        this.dtTrigger.next(true);
      },
      error: (err: HttpErrorResponse) => {
        this.loading = false;
        this.messageService.showError(err);
      },
      complete: () => {
        this.loading = false;
      }
    })
  }

  ngOnDestroy() {
    this.dtTrigger.unsubscribe();
  }

  onDepartmentSaved(department: Department) {
    this.resetSelected();
    this.loadData();
  }

  onShowDialog(department: Department): void {
    this.isNew = department.departmentId === 0;
    this.selectedDepartment = { ...department }

    this.showDialog = true;
  }

  private resetSelected(): void {
    this.newDepartment = Reset.department();
    this.selectedDepartment = Reset.department();
  }
}
